<template>
    <!--   </v-container>-->
    <v-sheet style="background-color:#fff;height:100%">
        <v-card elevation="0">
            <v-card-title>
            ISRCs
            <div class="flex-grow-1"></div>
            <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar ISRC"
                single-line
                hide-details
            ></v-text-field>
            </v-card-title>
            <v-data-table
            :footer-props="{itemsPerPageOptions:[50,100,200]}"
            :headers="headers"
            :items="isrcs"
            :search="search"
            >

                <template v-slot:item.actions="{ item }">
                    <v-btn icon text :to="{name:'isrc_edit',params:{id:item.id}}">
                        &nbsp;<v-icon small class="mr-2" outline>pageview</v-icon>
                    </v-btn>
                </template>
                
            </v-data-table>
        </v-card>
    </v-sheet>
</template>

<script>
import IsrcsService from "../../../app/rest/isrcs"

var isrcsService = null;

export default {
    components:{ },
    data: () => ({
        search: '',
        isrcs:[],
        headers: [
          {
            text: 'Nome do produto',
            align: 'left',
            sortable: false,
            value: 'product_name',
          },      
          { text: 'Nome da faixa', value: 'track_name' },
          { text: 'ISRC', value: 'isrc' },         
          { text: 'Data de criação', value: 'created_at' },
          { text:'Ações', value:'actions'}
        ],
    }),
    beforeCreate:function(){
        this.$store.dispatch('loading')
        isrcsService = IsrcsService.build();
        isrcsService.get_all().then( e =>{
            if(e.status=="ok"){
                this.isrcs = e.items.isrcs;
            }

        }).catch( e =>{
            
        }).finally( () =>{
             this.$store.dispatch('loading', false)
        });
    },
    methods:{
       
    }
};
</script>